<ng-container *ngIf="!!photo.hasError">
    <tg-aspect-ratio class="tm-list-photo-card__error" ratio="1x1">
        <button class="tm-list-photo-card__error-button">
            <span class="tm-list-photo-card__error-flex-container">
                <span class="tm-list-photo-card__error-icon-wrapper">
                    <tg-icon
                        class="tm-list-photo-card__error-icon"
                        name="basic-warning-framed"
                        role="presentation"
                    >
                    </tg-icon>
                </span>
                <span class="tm-list-photo-card__error-text">
                    {{ photo.errorMessage }}
                </span>
                <span class="tm-list-photo-card__error-action-text" *ngIf="activatable">
                    <tg-icon role="presentation" name="bin"> </tg-icon>
                    Remove
                    <span class="h-visually-hidden"> invalid photos </span>
                </span>
            </span>
        </button>
    </tg-aspect-ratio>
</ng-container>
<ng-container *ngIf="!photo.hasError">
    <tg-aspect-ratio
        *ngIf="photo.loading && !url"
        class="tm-list-photo-card__loading"
        ratio="1x1"
    >
    </tg-aspect-ratio>
    <tg-aspect-ratio
        *ngIf="photo.loading && !!url"
        [imageUrl]="url"
        class="tm-list-photo-card__loading"
        ratio="1x1"
    >
    </tg-aspect-ratio>
    <tg-aspect-ratio
        *ngIf="!photo.loading"
        [imageUrl]="url"
        aria-label="listing image"
        class="tm-list-photo-card__valid"
        [ngClass]="{'thumbnail': isThumbnail}"
        ratio="1x1"
    >
        <ng-content></ng-content>
    </tg-aspect-ratio>
</ng-container>
